import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface SelectableChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
  icon?: ReactNode;
}
export function SelectableChip({
  label,
  selected,
  onToggle,
  icon
}: SelectableChipProps) {
  return <motion.button whileTap={{
    scale: 0.98
  }} onClick={onToggle} className={`w-full min-h-[48px] rounded-lg px-4 py-3 flex items-center justify-between border-2 text-left transition-colors ${selected ? 'bg-orange-500/10 border-orange-500 text-orange-400' : 'bg-slate-800 border-slate-700 text-slate-300 hover:border-slate-600'}`} data-id="element-1090">
      <div className="flex items-center gap-3" data-id="element-1091">
        {icon && <div className={selected ? 'text-orange-500' : 'text-slate-500'} data-id="element-1092">
            {icon}
          </div>}
        <span className="font-medium text-sm leading-tight" data-id="element-1093">{label}</span>
      </div>
      {selected && <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} className="flex-shrink-0 ml-2" data-id="element-1094">
          <CheckIcon className="w-5 h-5 text-orange-500" data-id="element-1095" />
        </motion.div>}
    </motion.button>;
}